module.exports = __webpack_public_path__ + "static/media/mv.d4184a89.jpg";